import fetchClient from '@/lib/fetch'

export interface ImpersonationStatusResponse {
  isImpersonating: boolean
  originalUser?: {
    id: string
    email: string
    identity?: {
      firstname: string
      lastname: string
    }
  }
  targetUser?: {
    id: string
    email: string
  }
}

export interface StartImpersonationResponse {
  message: string
  token: string
  targetUser: {
    id: string
    email: string
  }
  impersonationLogId: string
}

export interface StopImpersonationResponse {
  message: string
  token: string
  user: {
    id: string
    email: string
  }
}

/**
 * Start impersonating a user
 * @param targetUserId - ID of the user to impersonate
 * @param reason - Reason for impersonation (required for GDPR compliance)
 */
export function startImpersonation(
  targetUserId: string,
  reason: string
): Promise<StartImpersonationResponse> {
  return fetchClient(`/v1/admin/impersonate/${targetUserId}`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  })
}

/**
 * Stop impersonating and return to original admin session
 */
export function stopImpersonation(): Promise<StopImpersonationResponse> {
  return fetchClient('/v1/admin/stop-impersonation', {
    method: 'POST',
  })
}

/**
 * Get current impersonation status
 */
export function getImpersonationStatus(): Promise<ImpersonationStatusResponse> {
  return fetchClient('/v1/admin/impersonation-status', {
    method: 'GET',
  })
}

export const IMPERSONATION_STATUS_QUERY_KEY = 'IMPERSONATION_STATUS'
